import { render } from "./InitView.vue?vue&type=template&id=6a658932&ts=true"
import script from "./InitView.vue?vue&type=script&lang=ts"
export * from "./InitView.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__